import { Record, Map } from "immutable";

export default Record({
  isRemoveUserModalVisible: false,
  data: [],
  tooltip: new Map([]),
  loading: false
});



// WEBPACK FOOTER //
// ./src/common/users/table.js